export default "__VITE_ASSET__JOp5_v1___"